module.exports = __webpack_public_path__ + "img/add-payment.2ae5324b.png";